import React from 'react';
import { Box } from '@chakra-ui/react';

import FormInput from '../../../../../../components/form/FormInput';
import { requiredInfoStack } from '../formStacks';

const InsuredRequiredInfoSection = ({ useFormMethods }) => (
  <Box>
    {requiredInfoStack.map(input => (
      <FormInput
        disableEnterKey
        caption={input?.caption}
        cypressId={input?.cypressId}
        dataAnalyticsId={input.dataAnalyticsId}
        dusk={input.dusk}
        inputName={input.name}
        key={input.name}
        labelName={input.label}
        placeholder={input.placeholder}
        required={input?.required}
        toolTip={input?.toolTip}
        type={input?.type}
        useFormMethods={useFormMethods}
        validationRules={input?.validationRules}
      />
    ))}
  </Box>
);

export default InsuredRequiredInfoSection;
